import { render, staticRenderFns } from "./CategoryImageCarousel.vue?vue&type=template&id=6652f471&"
import script from "./CategoryImageCarousel.vue?vue&type=script&lang=js&"
export * from "./CategoryImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ben/Documents/GitHub/casa-padrino-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6652f471')) {
      api.createRecord('6652f471', component.options)
    } else {
      api.reload('6652f471', component.options)
    }
    module.hot.accept("./CategoryImageCarousel.vue?vue&type=template&id=6652f471&", function () {
      api.rerender('6652f471', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/casa/CategoryImageCarousel.vue"
export default component.exports